var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDropdown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71094 5.78906C4.86719 5.92969 5.04688 6 5.25 6C5.45312 6 5.63281 5.92969 5.78906 5.78906L10.2891 1.28906C10.4297 1.13281 10.5 0.953125 10.5 0.75C10.5 0.546875 10.4297 0.367188 10.2891 0.210938C10.1328 0.0703125 9.95312 0 9.75 0C9.54688 0 9.36719 0.0703125 9.21094 0.210938L5.25 4.19531L1.28906 0.210938C1.13281 0.0703125 0.953125 0 0.75 0C0.546875 0 0.367188 0.0703125 0.210938 0.210938C0.0703125 0.367188 0 0.546875 0 0.75C0 0.953125 0.0703125 1.13281 0.210938 1.28906L4.71094 5.78906Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDropdown);
export default __webpack_public_path__ + "static/media/chevron-dropdown.16d71e56b011cd6f49a0c02f592ff24d.svg";
export { ForwardRef as ReactComponent };